import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=58c82af0&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=58c82af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c82af0",
  null
  
)

export default component.exports